namespace GeniuzPOS.ReportMasterData {
    export class Report_1407Columns {
        static columnsKey = 'ReportMasterData.Report_1407';
    }
}
